/**
 * specialMessageColors — the special-message palette, in a leaf with no imports.
 *
 * WHY ITS OWN FILE (PR-S, 2026-09-22). `services/agenticWorkflows/handlers.ts` is
 * on the first-paint path and used to import this from the chat's styles.ts —
 * which pulled ~30 KB of chat styles onto every signed-out visitor's first load
 * for five colour strings. styles.ts imports and re-exports it, so every
 * existing import keeps working.
 */

/**
 * CSS variables for special message theming.
 * All special messages (deep research, formatting, status updates) use this consistent palette.
 */
export const SPECIAL_MESSAGE_COLORS = {
  // Prest0 brand scheme (2026-08-12 owner directive): special-message chrome
  // rides the platform palette — warm ink + gold — never a one-off blue.
  // Distinction comes from contrast (ink on gold-tinted neutrals), not hue.
  /** Primary accent color for titles and icons */
  accent: '#1C1917',
  /** Light background for status badges/icons */
  accentBg: 'rgba(198, 167, 94, 0.14)',
  /** Subtle border for visual distinction */
  border: '#E0D5BC',
  /** Secondary text color for subtitles */
  subtitle: '#6B6459',
  /** Helper/muted text color */
  muted: 'var(--brand-text-muted)',
} as const;
